<template>
    <FrequencyComponent ref="frequencyComponent" :component="component" />
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
import FrequencyComponent from "@/builder/components/frequency/FrequencyComponent.vue";
import { IFrequencyComponent } from "@/builder/interfaces";

export default defineComponent({
    name: "FrequencyRenderContainer",
    components: {
        FrequencyComponent,
    },
    props: {
        component: {
            type: Object as PropType<IFrequencyComponent>,
            required: true
        }
    }
});
</script>
